/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiUserTasksGetLastSelectedIdParameter,
  ApiUserTasksGetPageParameter,
  CreateAppointmentHourRequest,
  CreateSpecialHourRequest,
  ExcludeAppointmentDayRequest,
  PaginatedResultOfGetAppointmentExclusionResponse,
  PaginatedResultOfGetAppointmentHourResponse,
  PaginatedResultOfGetSpecialHourResponse,
  Result,
  ResultOfCreateAppointmentHourResponse,
  ResultOfCreateSpecialHourResponse,
  ResultOfExcludeAppointmentDayResponse,
} from '../models/index';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterToJSON,
    CreateAppointmentHourRequestFromJSON,
    CreateAppointmentHourRequestToJSON,
    CreateSpecialHourRequestFromJSON,
    CreateSpecialHourRequestToJSON,
    ExcludeAppointmentDayRequestFromJSON,
    ExcludeAppointmentDayRequestToJSON,
    PaginatedResultOfGetAppointmentExclusionResponseFromJSON,
    PaginatedResultOfGetAppointmentExclusionResponseToJSON,
    PaginatedResultOfGetAppointmentHourResponseFromJSON,
    PaginatedResultOfGetAppointmentHourResponseToJSON,
    PaginatedResultOfGetSpecialHourResponseFromJSON,
    PaginatedResultOfGetSpecialHourResponseToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfCreateAppointmentHourResponseFromJSON,
    ResultOfCreateAppointmentHourResponseToJSON,
    ResultOfCreateSpecialHourResponseFromJSON,
    ResultOfCreateSpecialHourResponseToJSON,
    ResultOfExcludeAppointmentDayResponseFromJSON,
    ResultOfExcludeAppointmentDayResponseToJSON,
} from '../models/index';

export interface ApiAvailabilityAppointmentExclusionIdDeleteRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiAvailabilityAppointmentHoursIdDeleteRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiAvailabilityAppointmentHoursPostRequest {
    createAppointmentHourRequest: CreateAppointmentHourRequest;
    xTenantID?: number;
}

export interface ApiAvailabilityExcludeAppointmentHoursPostRequest {
    excludeAppointmentDayRequest: ExcludeAppointmentDayRequest;
    xTenantID?: number;
}

export interface ApiAvailabilitySpecialAppointmentHoursIdDeleteRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiAvailabilitySpecialAppointmentHoursPostRequest {
    createSpecialHourRequest: CreateSpecialHourRequest;
    xTenantID?: number;
}

export interface ApiAvailabilityTeacherIdAppointmentExclusionsGetRequest {
    teacherId: number;
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
}

export interface ApiAvailabilityTeacherIdAppointmentHoursGetRequest {
    teacherId: number;
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
}

export interface ApiAvailabilityTeacherIdSpecialAppointmentHoursGetRequest {
    teacherId: number;
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
}

/**
 * 
 */
export class TeachersAvailabilityApi extends runtime.BaseAPI {

    /**
     * Delete appointment exclusion
     */
    async apiAvailabilityAppointmentExclusionIdDeleteRaw(requestParameters: ApiAvailabilityAppointmentExclusionIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiAvailabilityAppointmentExclusionIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/availability/appointment-exclusion/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete appointment exclusion
     */
    async apiAvailabilityAppointmentExclusionIdDelete(requestParameters: ApiAvailabilityAppointmentExclusionIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAvailabilityAppointmentExclusionIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Delete appointment hours
     */
    async apiAvailabilityAppointmentHoursIdDeleteRaw(requestParameters: ApiAvailabilityAppointmentHoursIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiAvailabilityAppointmentHoursIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/availability/appointment-hours/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete appointment hours
     */
    async apiAvailabilityAppointmentHoursIdDelete(requestParameters: ApiAvailabilityAppointmentHoursIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAvailabilityAppointmentHoursIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Weekly hours are the normal hours that staff member is available week to week for privates & appointments
     * Create appointment hours
     */
    async apiAvailabilityAppointmentHoursPostRaw(requestParameters: ApiAvailabilityAppointmentHoursPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfCreateAppointmentHourResponse>> {
        if (requestParameters['createAppointmentHourRequest'] == null) {
            throw new runtime.RequiredError(
                'createAppointmentHourRequest',
                'Required parameter "createAppointmentHourRequest" was null or undefined when calling apiAvailabilityAppointmentHoursPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/availability/appointment-hours`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAppointmentHourRequestToJSON(requestParameters['createAppointmentHourRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfCreateAppointmentHourResponseFromJSON(jsonValue));
    }

    /**
     * Weekly hours are the normal hours that staff member is available week to week for privates & appointments
     * Create appointment hours
     */
    async apiAvailabilityAppointmentHoursPost(requestParameters: ApiAvailabilityAppointmentHoursPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfCreateAppointmentHourResponse> {
        const response = await this.apiAvailabilityAppointmentHoursPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates an exclusion for a teacher\'s appointment hours on a specific date. You can provide StartTime and EndTime to block part of the day, or leave both null to exclude the entire day. This can be used to override the teacher\'s regular weekly schedule for special circumstances.
     * Create an appointment exclusion
     */
    async apiAvailabilityExcludeAppointmentHoursPostRaw(requestParameters: ApiAvailabilityExcludeAppointmentHoursPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfExcludeAppointmentDayResponse>> {
        if (requestParameters['excludeAppointmentDayRequest'] == null) {
            throw new runtime.RequiredError(
                'excludeAppointmentDayRequest',
                'Required parameter "excludeAppointmentDayRequest" was null or undefined when calling apiAvailabilityExcludeAppointmentHoursPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/availability/exclude-appointment-hours`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExcludeAppointmentDayRequestToJSON(requestParameters['excludeAppointmentDayRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfExcludeAppointmentDayResponseFromJSON(jsonValue));
    }

    /**
     * Creates an exclusion for a teacher\'s appointment hours on a specific date. You can provide StartTime and EndTime to block part of the day, or leave both null to exclude the entire day. This can be used to override the teacher\'s regular weekly schedule for special circumstances.
     * Create an appointment exclusion
     */
    async apiAvailabilityExcludeAppointmentHoursPost(requestParameters: ApiAvailabilityExcludeAppointmentHoursPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfExcludeAppointmentDayResponse> {
        const response = await this.apiAvailabilityExcludeAppointmentHoursPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete special appointment hours
     */
    async apiAvailabilitySpecialAppointmentHoursIdDeleteRaw(requestParameters: ApiAvailabilitySpecialAppointmentHoursIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiAvailabilitySpecialAppointmentHoursIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/availability/special-appointment-hours/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete special appointment hours
     */
    async apiAvailabilitySpecialAppointmentHoursIdDelete(requestParameters: ApiAvailabilitySpecialAppointmentHoursIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAvailabilitySpecialAppointmentHoursIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Special hours can be used as overrides for weekly hours, where this staff member has a different schedule on a certain date
     * Create special appointment hours
     */
    async apiAvailabilitySpecialAppointmentHoursPostRaw(requestParameters: ApiAvailabilitySpecialAppointmentHoursPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfCreateSpecialHourResponse>> {
        if (requestParameters['createSpecialHourRequest'] == null) {
            throw new runtime.RequiredError(
                'createSpecialHourRequest',
                'Required parameter "createSpecialHourRequest" was null or undefined when calling apiAvailabilitySpecialAppointmentHoursPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/availability/special-appointment-hours`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSpecialHourRequestToJSON(requestParameters['createSpecialHourRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfCreateSpecialHourResponseFromJSON(jsonValue));
    }

    /**
     * Special hours can be used as overrides for weekly hours, where this staff member has a different schedule on a certain date
     * Create special appointment hours
     */
    async apiAvailabilitySpecialAppointmentHoursPost(requestParameters: ApiAvailabilitySpecialAppointmentHoursPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfCreateSpecialHourResponse> {
        const response = await this.apiAvailabilitySpecialAppointmentHoursPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns paginated exclusion days for the teacher specified by teacherId.
     * Get appointment exclusion days for a teacher
     */
    async apiAvailabilityTeacherIdAppointmentExclusionsGetRaw(requestParameters: ApiAvailabilityTeacherIdAppointmentExclusionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetAppointmentExclusionResponse>> {
        if (requestParameters['teacherId'] == null) {
            throw new runtime.RequiredError(
                'teacherId',
                'Required parameter "teacherId" was null or undefined when calling apiAvailabilityTeacherIdAppointmentExclusionsGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/availability/{teacherId}/appointment-exclusions`;
        urlPath = urlPath.replace(`{${"teacherId"}}`, encodeURIComponent(String(requestParameters['teacherId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetAppointmentExclusionResponseFromJSON(jsonValue));
    }

    /**
     * Returns paginated exclusion days for the teacher specified by teacherId.
     * Get appointment exclusion days for a teacher
     */
    async apiAvailabilityTeacherIdAppointmentExclusionsGet(requestParameters: ApiAvailabilityTeacherIdAppointmentExclusionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetAppointmentExclusionResponse> {
        const response = await this.apiAvailabilityTeacherIdAppointmentExclusionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns paginated appointment hours for the teacher specified by teacherId.
     * Get appointment hours for a teacher
     */
    async apiAvailabilityTeacherIdAppointmentHoursGetRaw(requestParameters: ApiAvailabilityTeacherIdAppointmentHoursGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetAppointmentHourResponse>> {
        if (requestParameters['teacherId'] == null) {
            throw new runtime.RequiredError(
                'teacherId',
                'Required parameter "teacherId" was null or undefined when calling apiAvailabilityTeacherIdAppointmentHoursGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/availability/{teacherId}/appointment-hours`;
        urlPath = urlPath.replace(`{${"teacherId"}}`, encodeURIComponent(String(requestParameters['teacherId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetAppointmentHourResponseFromJSON(jsonValue));
    }

    /**
     * Returns paginated appointment hours for the teacher specified by teacherId.
     * Get appointment hours for a teacher
     */
    async apiAvailabilityTeacherIdAppointmentHoursGet(requestParameters: ApiAvailabilityTeacherIdAppointmentHoursGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetAppointmentHourResponse> {
        const response = await this.apiAvailabilityTeacherIdAppointmentHoursGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns paginated special appointment hours for the teacher specified by teacherId.
     * Get special appointment hours for a teacher
     */
    async apiAvailabilityTeacherIdSpecialAppointmentHoursGetRaw(requestParameters: ApiAvailabilityTeacherIdSpecialAppointmentHoursGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetSpecialHourResponse>> {
        if (requestParameters['teacherId'] == null) {
            throw new runtime.RequiredError(
                'teacherId',
                'Required parameter "teacherId" was null or undefined when calling apiAvailabilityTeacherIdSpecialAppointmentHoursGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/availability/{teacherId}/special-appointment-hours`;
        urlPath = urlPath.replace(`{${"teacherId"}}`, encodeURIComponent(String(requestParameters['teacherId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetSpecialHourResponseFromJSON(jsonValue));
    }

    /**
     * Returns paginated special appointment hours for the teacher specified by teacherId.
     * Get special appointment hours for a teacher
     */
    async apiAvailabilityTeacherIdSpecialAppointmentHoursGet(requestParameters: ApiAvailabilityTeacherIdSpecialAppointmentHoursGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetSpecialHourResponse> {
        const response = await this.apiAvailabilityTeacherIdSpecialAppointmentHoursGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
